module.exports = __webpack_public_path__ + "img/shahdab.470fa302.png";